import { DefaultState } from 'features/types';

export enum EmploymentStatuses {
  OpenToWork = 'OpenToWork',
  Employed = 'Employed',
  Hiring = 'Hiring',
  SeekingMentor = 'SeekingMentor',
  OfferingMentorship = 'OfferingMentorship',
}

export type SetEmploymentStatusForm = {
  employmentStatus?: EmploymentStatuses[];
};

export type EmploymentStatusFormData = {
  employmentStatus?: EmploymentStatuses[];
};

export type JobSeekerEmploymentStatusState = DefaultState & {
  data: EmploymentStatusFormData | null;
};
